import { render, staticRenderFns } from "./DifferentQuery.vue?vue&type=template&id=0cfd6956&scoped=true&"
import script from "./DifferentQuery.vue?vue&type=script&lang=js&"
export * from "./DifferentQuery.vue?vue&type=script&lang=js&"
import style1 from "./DifferentQuery.vue?vue&type=style&index=1&id=0cfd6956&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0cfd6956",
  null
  
)

export default component.exports